import React, { useEffect, useRef } from "react";
import {
  StatisticsContainer,
  StatisticsTitle,
  StatContainer,
  StatBox,
  StatText,
  BoldText,
  StatNumberContainer,
  StatNumber,
  StatPercent,
} from "./styles";

const StatisticsSection = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const boxRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          boxRefs.current.forEach((box) => {
            if (box) box.classList.add("visible");
          });
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <StatisticsContainer ref={sectionRef}>
      <StatisticsTitle>
        {"스마일보건을 이용중인\n1,320명의 선생님들께 물어보았습니다."}
      </StatisticsTitle>
      <StatContainer>
        {[0, 1, 2].map((index) => (
          <StatBox key={index} ref={(el) => (boxRefs.current[index] = el)}>
            {index === 0 && (
              <>
                <StatText>
                  97.8%의 사용자가{"\n"}내년에도 스마일보건을{"\n"}
                  <BoldText>계속 더 사용할 생각</BoldText>이라고{"\n"}
                  답변하셨습니다.
                </StatText>
                <StatNumberContainer>
                  <StatNumber>97.8</StatNumber>
                  <StatPercent>%</StatPercent>
                </StatNumberContainer>
              </>
            )}
            {index === 1 && (
              <>
                <StatText>
                  97.5%의 사용자가{"\n"}
                  스마일보건의 사용에{"\n"}
                  <BoldText>만족</BoldText>한다고{"\n"}
                  답변하셨습니다.{"\n"}
                </StatText>
                <StatNumberContainer>
                  <StatNumber>97.5</StatNumber>
                  <StatPercent>%</StatPercent>
                </StatNumberContainer>
              </>
            )}
            {index === 2 && (
              <>
                <StatText>
                  45.2%의 사용자가{"\n"}
                  기존 타 보건일지 대비{"\n"}
                  <BoldText>40% 이상 업무가 향상</BoldText>
                  {"\n"}
                  되었다고 답변하셨습니다.{"\n"}
                </StatText>
                <StatNumberContainer>
                  <StatNumber>40</StatNumber>
                  <StatPercent>%</StatPercent>
                </StatNumberContainer>
              </>
            )}
          </StatBox>
        ))}
      </StatContainer>
    </StatisticsContainer>
  );
};

export default StatisticsSection;
